import React from "react";

import { Text } from "@/components/atoms/Text";

type TrustCardProps = {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  description: string;
  caption?: string;
};

const TrustCard = ({
  caption,
  icon,
  title,
  subtitle,
  description,
}: TrustCardProps) => (
  <div className="tw-flex tw-flex-col tw-gap-12 tw-rounded-4 tw-border tw-border-gray-700 tw-bg-gray-900 tw-px-20 tw-py-28">
    <div className="tw-flex tw-items-center tw-gap-[10px]">
      <div className="tw-shrink-0 tw-text-brand-white">{icon}</div>
      <Text element="p" typeface="headline-2-m" className="tw-text-brand-white">
        {title}
      </Text>
    </div>
    <Text element="p" typeface="body-2-m" className="tw-text-purple-400">
      {subtitle}
    </Text>
    <Text element="p" typeface="body-2" className="tw-text-gray-500">
      {description}
    </Text>
    {caption && (
      <Text element="p" typeface="caption-2" className="tw-text-gray-500">
        {caption}
      </Text>
    )}
  </div>
);

export { TrustCard };
